import { render, staticRenderFns } from "./modal-register.vue?vue&type=template&id=80721d1c&scoped=true&"
import script from "./modal-register.vue?vue&type=script&lang=js&"
export * from "./modal-register.vue?vue&type=script&lang=js&"
import style0 from "./modal-register.vue?vue&type=style&index=0&id=80721d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80721d1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80721d1c')) {
      api.createRecord('80721d1c', component.options)
    } else {
      api.reload('80721d1c', component.options)
    }
    module.hot.accept("./modal-register.vue?vue&type=template&id=80721d1c&scoped=true&", function () {
      api.rerender('80721d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/theme/components/modals/modal-register.vue"
export default component.exports